import { render, staticRenderFns } from "./DialogAlertaDocumentos.vue?vue&type=template&id=38c84339&scoped=true&"
import script from "./DialogAlertaDocumentos.vue?vue&type=script&lang=js&"
export * from "./DialogAlertaDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./DialogAlertaDocumentos.vue?vue&type=style&index=0&id=38c84339&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c84339",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
